import { render, staticRenderFns } from "./WorldAnimation.vue?vue&type=template&id=38eb1402&"
import script from "./WorldAnimation.vue?vue&type=script&lang=js&"
export * from "./WorldAnimation.vue?vue&type=script&lang=js&"
import style0 from "./WorldAnimation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports